import * as Yup from 'yup'
import { validation as validationGeneral } from './GeneralDataForm/validation'
import { validation as validationPago }    from './PagoDataForm/validation'

export const validationSchema = Yup.object().shape({
    ...validationGeneral,
    ...validationPago,
})